function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.057 12.939v-.55c0-5.486-3.647-9.902-8.176-9.902h-.908c-4.53 0-8.176 4.416-8.176 9.902.013 8.402-.021 18.002.012 26.405h3.621V12.389c0-3.048 2.026-6.051 4.542-6.051h.909c2.516 0 4.542 3.003 4.542 6.05v.551z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.725 19.54H19.487v3.85h16.24zM53.043 12.939v-.55c0-5.486-3.647-9.902-8.176-9.902h-.908c-4.53 0-8.176 4.416-8.176 9.902.013 8.402-.021 18.002.012 26.405h3.621V12.389c0-3.048 2.026-6.051 4.543-6.051h.908c2.517 0 4.542 3.003 4.542 6.05v.551zM35.725 30.542H19.487v3.85h16.24zM1.333 48.295s10.415 5.272 16.093 5.81c7.535.715 14.878-2.98 22.425-3.556 4.385-.335 13.191.062 13.191.062s-8.088-2.977-13.19-3.13c-8.04-.242-14.368 3.662-22.426 3.556-5.958-.078-16.093-3.06-16.093-3.06"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.333 41.693s10.415 5.272 16.093 5.81c7.535.715 14.878-2.98 22.425-3.556 4.385-.335 13.191.062 13.191.062s-8.088-2.977-13.19-3.13c-8.04-.242-14.368 3.662-22.426 3.556-5.958-.078-16.093-3.06-16.093-3.06"
}));

var SvgPool = function SvgPool(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPool, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Pool.e629bc03.svg";
export { ForwardRef as ReactComponent };